import { ListOrdered } from "lucide-react";

import type { BlogHeading } from "@/lib/blog/format";

/**
 * «في المقال ده»: static, always expanded, no scroll-spy. Headings come from +data.ts
 * (extractH2Headings on the raw MDX); their ids are the same headingId() the h2 override uses.
 * In-page hash links are plain anchors and are not tracked.
 */
export function Toc({ headings }: { headings: BlogHeading[] }) {
  if (headings.length < 3) return null;
  return (
    <nav aria-labelledby="blog-toc" className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-8">
      <div className="flex items-center gap-2 mb-2">
        <ListOrdered className="h-4 w-4 text-gray-900" aria-hidden="true" />
        <span id="blog-toc" className="text-sm font-bold text-gray-900">
          في المقال ده
        </span>
      </div>
      <ol className="space-y-2">
        {headings.map(({ text, id }) => (
          <li key={id}>
            <a
              href={`#${id}`}
              className="text-sm text-warmOrange-700 hover:text-warmOrange-800 min-h-11 md:min-h-0 flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warmOrange-500 rounded"
            >
              {text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Toc;
